import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProgressBar = ({ percentage }) => {
  return (
    <Wrapper>
      <Progress style={{width: `${percentage}%`}} />
    </Wrapper>
  )
};

ProgressBar.propTypes = {
  percentage: PropTypes.number,
};

const Wrapper = styled.div`
  background: #ccc;
  border-radius: 4px;
  height: 6px;
  margin: 15px 0 20px 0;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const Progress = styled.div`
  background-color: var(--quiz-primary-color);
  color: black;
  height: 100%;
`;

export default ProgressBar;
